import React, {useState} from 'react';
import {Routes, Route} from 'react-router-dom';

import { NavBar, Feed, PostDetail, CreatePost, Search, UserProfile } from '../components';

const Post = ({ user }) => {
  
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className='px-2 md:px-5'>
      <div className='bg-white'>
      <NavBar
      searchTerm={searchTerm} setSearchTerm={setSearchTerm} user={user}
      />
      <div className='h-full'>
        <Routes>
          <Route path='/' element={<Feed/>}/>
          <Route path='/user-profile/:userId' element={<UserProfile/>}/>
          <Route path='/category/:categoryId' element={<Feed/>}/>
          <Route path='/post-detail/:postId' element={<PostDetail user = {user}/>}/>
          <Route path='/create-post' element={<CreatePost user = {user}/>}/>
          <Route path='/search' element={<Search searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>}/>
        </Routes>
      </div>
      </div>
    </div>
  )
}

export default Post